Information about how much this advertisement product costs.
